
import React, { useState } from 'react';

export const QnASection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const qnaData = [
    {
      question: '모아타운과 재개발의 차이점은 무엇인가요?',
      answer: '모아타운은 공공지원을 받는 소규모 정비사업으로, 기존 재개발보다 절차가 간소하고 추진 기간이 단축됩니다. 또한 다구역 연계 방식을 통해 효율적인 개발이 가능하며, 주민 부담을 최소화하면서도 높은 사업성을 확보할 수 있습니다.'
    },
    {
      question: '내 대지지분과 입주권 배정은 어떤 관계인가요?',
      answer: '입주권 배정은 기본적으로 현재 보유하신 대지 면적에 비례하여 결정됩니다. 배정 원칙의 기본 구조는 관리계획 수립 시 확정되며, 세부 기준은 추후 공식 자료를 통해 상세히 안내해드릴 예정입니다.'
    },
    {
      question: '비용과 분담금은 언제 어떻게 발생하나요?',
      answer: '사업 추진 단계별로 설계비, 인허가비, 공사비 등이 발생합니다. 구체적인 발생 항목과 금액, 납부 시점은 관리계획 확정 이후 주민설명회를 통해 상세히 공지해드릴 예정입니다.'
    },
    {
      question: '불참 시 불이익이 있나요?',
      answer: '불참하시더라도 개별 존치는 가능합니다. 다만 주변 지역의 기반시설 개선 및 자산가치 상승 효과를 누리지 못할 수 있으며, 향후 개별 정비 시 더 많은 비용이 발생할 가능성이 있습니다.'
    }
  ];

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="qna" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            자주 묻는 질문
          </h2>
          <p className="text-lg text-gray-600">
            모아타운 사업에 대한 궁금한 점들을 확인해보세요
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {qnaData.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <h3 className="text-lg font-semibold text-gray-900 pr-4">
                    {item.question}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-green-500 text-xl`}></i>
                  </div>
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <div className="border-t border-gray-100 pt-4">
                      <p className="text-gray-600 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">더 궁금한 점이 있으시나요?</p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              문의하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
